import { render } from "./QuickContact.vue?vue&type=template&id=6d512296"
import script from "./QuickContact.vue?vue&type=script&lang=js"
export * from "./QuickContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__